import { getCurrentOrg } from '.';
import { AgentApiService } from '../services/agents-management';

export const generateVaultSecret = (agentId: string) => {
  return AgentApiService.addAgentSecret(agentId, getCurrentOrg());
};
